export default(name=>`data-${name.replace(/[A-Z]/g,match=>`-${match.toLowerCase()}`)}`);